import React from 'react';
import { Navigate } from 'react-router-dom';

import { loadable } from 'components/Loading';

const NotFound = loadable((props) => import('components/ErrorPage/NotFound'));
const ActiveRedirect = loadable((props) => import('components/ErrorPage/ActiveRedirect'));

// Home
const Home = loadable((props) => import('features/Home'));

// Solver
const SolverLayout = loadable((props) => import('features/Solvers'));
const SolverList = loadable((props) => import('features/Solvers/List'));
const SolverDetail = loadable((props) => import('features/Solvers/Detail'));

// Tools
const Tools = loadable((props) => import('features/Tools'));

// Sign up
const SignUp = loadable((props) => import('features/SignUp'));

// Result
const ResultLayout = loadable((props) => import('features/Results'));
const ResultQueue = loadable((props) => import('features/Results/Queue'));
const ResultDetail = loadable((props) => import('features/Results/Detail'));

// Statistics
const Statistics = loadable((props) => import('features/Statistics'));

// Competitions
const CompetitionsList = loadable((props) => import('features/Competitions/List'));
const CompetitionsDetail = loadable((props) => import('features/Competitions/Detail'));

// 控制台
const PrivateLayout = loadable((props) =>
  import('components/Layout/PrivateLayout')
);
const Problem = loadable((props) => import('features/Console/Problem'));
const ProblemDetail = loadable((props) =>
  import('features/Console/Problem/Detail')
);
const ProblemSet = loadable((props) => import('features/Console/ProblemSet'));
const ProblemSetDetail = loadable((props) =>
  import('features/Console/ProblemSet/Detail')
);
const Optimization = loadable((props) =>
  import('features/Console/Optimization')
);
const OptimizationDetailByProblem = loadable((props) =>
  import('features/Console/Optimization/Detail/DetailByProblem')
);
const OptimizationDetailByProblems = loadable((props) =>
  import('features/Console/Optimization/Detail/DetailByProblems')
);
const Result = loadable((props) => import('features/Console/Result'));
const Profile = loadable((props) => import('features/Console/Profile'));
const ProfileHome = loadable((props) =>
  import('features/Console/Profile/Home')
);
const ProfileAccount = loadable((props) =>
  import('features/Console/Profile/Account')
);

const routes = [
  { index: true, element: <Home /> },
  { path: '*', element: <NotFound /> },
];

export default routes;
